var _style, _g, _g2, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1280 600",
    style: {
      enableBackground: "new 0 0 1280 600"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#2D97D0;}\n\t.st2{fill:#2D97D0;fill-opacity:0.5;}\n\t.st3{fill:url(#SVGID_1_);fill-opacity:0.5;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M988.6,385.7c-340.2,85.8-489.6-210.6-808.1-126c-78.7,21-135.7,56.6-180.5,89.6V600h1280V318.2 C1162.3,307.5,1097.7,358.2,988.6,385.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0,349.3c44.8-33,101.8-68.6,180.5-89.5c318.5-84.7,468,211.8,808.1,125.9c109.1-27.5,173.7-78.2,291.4-67.5 V0H0V349.3z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M971.8,429.2C631.7,515,482.2,218.6,163.7,303.3C94.5,321.6,42.1,351.4,0,380.7V600h1280V363.6 C1151.4,346.2,1086,400.4,971.8,429.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M0,380.7c42.1-29.3,94.5-59.1,163.7-77.5c318.5-84.7,468,211.8,808.1,125.9c114.2-28.8,179.6-83,308.2-65.6V0 H0V380.7z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M960,411.2C619.9,497,470.4,200.6,151.9,285.3C89,302,40,328.1,0,354.7V600h1280V347.4 c-3.4-0.6-6.9-1.1-10.4-1.6C1140.1,327.8,1074.6,382.3,960,411.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 213.4812,
    x2: 1280,
    y2: 213.4812
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2D97D0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5EC5F8"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M0,354.7c40-26.6,89-52.7,151.9-69.5c318.5-84.6,468,211.8,808.1,126c114.6-28.9,180.1-83.4,309.6-65.4 c3.5,0.5,6.9,1,10.4,1.6V0H0V354.7z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBg);
export default __webpack_public_path__ + "static/media/login-bg.84b1fc5d4b6c1d5001d2f03033e9a97f.svg";
export { ForwardRef as ReactComponent };